import noCommentGuardsImage from 'assets/feature-svgs/comment-guard.svg';
import htmlElementsImg from 'assets/feature-svgs/html-elements.svg';
import leadPopupsImg from 'assets/feature-svgs/lead-popups.svg';
import { ITEMS } from '../../../../common/constants/items';
import tooltips from '../../../constants/toolTipInfo';
import { BotBuilderRoutes } from '../../../../routes/bot-builder-routes';
import { sectionNames } from '../../../sections/sectionNames';
import { LinkTypes, PromoterTypes } from '@mm/state/model/PromoterModel';
import { useMemo } from 'react';

export const useStartBotDetails = (promoterKind: LinkTypes) => {
  const START_BOT_PROMOTER_LOOKUP = {
    [PromoterTypes.CUSTOMER_CHAT]: {
      tipInfo: undefined,
      singularPromoterName: 'Customer Chat Widget',
      featureGroupName: sectionNames.websiteChat,
      promoterName: ITEMS.CUSTOMER_CHAT,
      routes: {
        index: BotBuilderRoutes.customerChat,
        edit: BotBuilderRoutes.customerChatEdit,
      },
      noPromoterImage: htmlElementsImg,
    },
    [PromoterTypes.FB_COMMENT_GUARD]: {
      tipInfo: tooltips.commentGuards,
      singularPromoterName: 'Comment Guard',
      featureGroupName: '',
      promoterName: ITEMS.FB_COMMENT_GUARD,
      routes: {
        index: BotBuilderRoutes.commentGuards,
        edit: BotBuilderRoutes.commentGuardEdit,
      },
      noPromoterImage: noCommentGuardsImage,
    },
    [PromoterTypes.LINK]: {
      singularPromoterName: 'Share Link',
      featureGroupName: sectionNames.websiteChat,
      promoterName: ITEMS.SHARE_LINKS,
      routes: {
        index: BotBuilderRoutes.shareLinks,
        edit: BotBuilderRoutes.shareLinkEdit,
      },
      noPromoterImage: htmlElementsImg,
    },
    [PromoterTypes.MESSENGER]: {
      singularPromoterName: 'Send to Messenger',
      featureGroupName: sectionNames.websiteChat,
      promoterName: ITEMS.HTML_ELEMENTS,
      routes: {
        index: BotBuilderRoutes.facebookOptIns,
        edit: BotBuilderRoutes.sendToMessengerEdit,
      },
      noPromoterImage: htmlElementsImg,
    },
    [PromoterTypes.CHECKBOX]: {
      singularPromoterName: 'Checkbox Plugin',
      featureGroupName: sectionNames.websiteChat,
      promoterName: ITEMS.HTML_ELEMENTS,
      routes: {
        index: BotBuilderRoutes.facebookOptIns,
        edit: BotBuilderRoutes.checkboxPluginEdit,
      },
      noPromoterImage: htmlElementsImg,
    },
    [PromoterTypes.OPTIN]: {
      singularPromoterName: 'Opt-in Popup',
      featureGroupName: sectionNames.sms,
      promoterName: ITEMS.LEAD_POPUPS,
      noPromoterImage: leadPopupsImg,
      routes: {
        index: BotBuilderRoutes.leadPopups,
        edit: BotBuilderRoutes.leadPopupsEdit,
      },
    },
    [PromoterTypes.INSTAGRAM_WELCOMER]: {
      singularPromoterName: 'Instagram DM Responder',
      featureGroupName: sectionNames.instagramWelcomer,
      promoterName: ITEMS.INSTAGRAM_WELCOMER,
      noPromoterImage: htmlElementsImg,
      routes: {
        index: BotBuilderRoutes.instagramWelcomer,
        edit: BotBuilderRoutes.instagramWelcomerEdit,
      },
    },
    [PromoterTypes.INSTAGRAM_STORY_MENTION]: {
      singularPromoterName: 'Instagram Story Mention',
      featureGroupName: sectionNames.instagramStoryMention,
      promoterName: ITEMS.INSTAGRAM_STORY_MENTION,
      noPromoterImage: htmlElementsImg,
      routes: {
        index: BotBuilderRoutes.instagramStoryMention,
        edit: BotBuilderRoutes.instagramStoryMentionEdit,
      },
    },
    [PromoterTypes.INSTAGRAM_STORY_REACTION]: {
      singularPromoterName: 'Instagram Story Reaction',
      featureGroupName: sectionNames.instagramStoryReactions,
      promoterName: ITEMS.INSTAGRAM_STORY_REACTIONS,
      noPromoterImage: htmlElementsImg,
      routes: {
        index: BotBuilderRoutes.chatStarters,
        edit: BotBuilderRoutes.instagramStoryReactionEdit,
      },
    },
    [PromoterTypes.INSTAGRAM_COMMENT_GUARD]: {
      singularPromoterName: 'Instagram Comment Guard',
      featureGroupName: sectionNames.instagramCommentGuard,
      routes: {
        index: BotBuilderRoutes.instagramWelcomer,
        edit: BotBuilderRoutes.instagramCommentGuardEdit,
      },
    },
    [PromoterTypes.INSTAGRAM_LIVE_COMMENT_GUARD]: {
      singularPromoterName: 'Instagram Live',
      featureGroupName: sectionNames.instagramLive,
      promoterName: ITEMS.INSTAGRAM_LIVE_COMMENT_GUARD,
      noPromoterImage: htmlElementsImg,
      routes: {
        index: BotBuilderRoutes.chatStarters,
        edit: BotBuilderRoutes.instagramLiveEdit,
      },
    },
  };

  return useMemo(() => START_BOT_PROMOTER_LOOKUP[promoterKind], [promoterKind]);
};
